import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'scheduleType', standalone: true})
export class ScheduleTypePipe implements PipeTransform {

    constructor() { }

    transform(value: string): string {
        return value !== 'Operating' ? `- ${value}` : '';
    }
}
